import React  from 'react';
import './App.css';
import './Queue.css';
import QueueLang from './QueueLang.json';

class QueueMain extends React.Component {

	constructor(props) {

		super(props);

		this.state = {
			intervalID: null,
			notebookArray: null,
			sourceArray: null,
		}
	}
		
	componentDidMount() {
		this.refreshData();
		this.intervalID = setInterval(() => {
			this.refreshData();
		}, 5*1000);
	}
	
	componentWillUnmount() {
		clearInterval(this.intervalID);
	}

	async refreshData() {
		var companyID = this.props.companyID;
		this.serverGetJobList(companyID);
	}

	async serverGetJobList(companyID) {

		if (companyID <= 0) {
			return null;
		}

		var baseURLAPI = this.props.baseURLAPI;
		var url = baseURLAPI + "/getjoblist?companyid=" + companyID;
		
		var jsonObj = null;
		
		try {
			var res = await fetch(url);
			jsonObj = await res.json();
		} catch (err) {
		}

		if (jsonObj === null) {
			return;
		}
		
		var notebookArray = jsonObj.notebook;
		var sourceArray = jsonObj.source;

		if ((notebookArray.length === 0) && (sourceArray.length === 0)) {
			clearInterval(this.intervalID);
		}

		this.setState({
			notebookArray: notebookArray,
			sourceArray: sourceArray,
		});
	}

	renderSourceOneJob(index, itemObj) {

		var key = "source-" + index;
		var filenameExt = itemObj.filename;
		var userFullName = itemObj.userFullName;
		var markdownValid = itemObj.markdownValid;
		var jsonExtractValid = itemObj.jsonExtractValid;
		var statusString = this.props.getLang(QueueLang, "waiting");
		if (markdownValid === 1) {
			statusString = this.props.getLang(QueueLang, "creatingMarkdown");
		}
		if (jsonExtractValid === 1) {
			statusString = this.props.getLang(QueueLang, "extractingJSON");
		}

		return (
			<tr key={key}>
				<td className="QueueMainSourceItem">{filenameExt}</td>
				<td className="QueueMainUserItem">{userFullName}</td>
				<td className="QueueMainStatusItem">{statusString}</td>
			</tr>
		);
	}
		
	renderSourceJobList() {
		
		var sourceArray = this.state.sourceArray;
		if (sourceArray === null) {
			return;
		}
		
		if (sourceArray.length === 0) {
			return (
				<div className="QueueMainStandardText">
					{this.props.getLang(QueueLang, "noSourceJobsFound")}
				</div>
			);
		}

		var i;
		var itemObj;
		var jsxCode;
		var jsxArray = [];
		
		for(i=0; i<sourceArray.length; i++) {
			itemObj = sourceArray[i];
			jsxCode = this.renderSourceOneJob(i, itemObj);
			jsxArray.push(jsxCode);
		}
		
		return (
			<div style={{width: "95vw", textAlign: "center"}}>
				<table style={{margin: "0 auto"}}>
					<thead>
						<tr>
							<th className="QueueMainSourceHeader">{this.props.getLang(QueueLang, "source")}</th>
							<th className="QueueMainUserHeader">{this.props.getLang(QueueLang, "user")}</th>
							<th className="QueueMainStatusHeader">{this.props.getLang(QueueLang, "status")}</th>
						</tr>
					</thead>
					<tbody>
						{jsxArray}
					</tbody>
				</table>
			</div>
		);
	}

	render() {
		return (
			<div className="QueueMainTopContainer">
				<div style={{height: "20px"}}></div>
				<div className="QueueMainTopTitle">{this.props.getLang(QueueLang, "queueMainTopTitle")}</div>
				<div style={{height: "20px"}}></div>
				{this.renderSourceJobList()}
				<div style={{height: "20px"}}></div>
			</div>
		);
	}
}

export default QueueMain;

